// extracted by mini-css-extract-plugin
export default {"header":"Analyse-module_header__3lceJ","resultsContainer":"Analyse-module_resultsContainer__1QNn5","seeMore":"Analyse-module_seeMore__3yYYW"};